import { t } from 'i18next'
import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import { store } from '#app/store'
import type { ManCodeApiConfiguration } from '#features/Configuration/ApiConfiguration'
import { wrapErrorLike } from '#features/ErrorHandling/errorHelpers'

type Status = { error?: unknown; message?: string; isLoading: boolean }
type UpdateStatusFunction = (status: Status) => void

export const loadManCode = async (
  manCodeConfiguration: ManCodeApiConfiguration,
  {
    setStatus,
    abortController,
    includeJournal,
  }: { setStatus?: UpdateStatusFunction; abortController?: AbortController; includeJournal?: boolean } = {},
) => {
  setStatus?.({ isLoading: true })

  const manCodeId = manCodeConfiguration.manCode

  const getCodeRequest = await store.dispatch(enhancedTmsApiService.endpoints.getApiCodeById.initiate({ id: manCodeId, includeJournal }))

  if (abortController?.signal.aborted) {
    return
  }

  if (getCodeRequest.error) {
    const error = wrapErrorLike(getCodeRequest.error, t('configuration.from-man-code.error.failed-get-code-request', 'Failed to get MAN-Code'))
    setStatus?.({
      error,
      isLoading: false,
      message: t('configuration.from-man-code.error.failed-get-code-request', 'Failed to get MAN-Code'),
    })
    throw error
  }

  const manCode = getCodeRequest.data?.code

  if (!manCode?.configuration) {
    const error = new Error(t('configuration.from-man-code.error.received-no-man-code', 'No MAN-Code received'))
    setStatus?.({ error, isLoading: false, message: error.message })
    throw error
  }

  setStatus?.({ isLoading: false })

  return manCode
}
